export default {
    ':root': [
        {
            title: 'cookie名称',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.keyName;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.keyName = value;
                }
            }
        },
        {
            title: '仅http可获取',
            type: 'switch',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.httpOnly;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.httpOnly = value;
                }
            }
        },
        {
            title: '过期时间（秒）',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.maxAge;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.maxAge = value;
                }
            }
        },
        {
            title: '域名',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.domain;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.domain = value;
                }
            }
        },
        {
            title: '路径',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.path;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.path = value;
                }
            }
        },
    ]
};
